<template>
  <div class="image-list">
    <div
      v-for="(img,index) in images"
      :key="index"
      class="image-box"
      :style="{ width: size, height: size }"
    >
      <img
        :src="img"
        alt=""
        :style="{ objectFit: fit }"
      >
      <div
        v-if="canPreview"
        class="image-cover"
      >
        <Icon
          type="ios-eye-outline"
          @click.native="handleView(img)"
        />
      </div>
    </div>
    <!-- 坑：Modal 外面必须包一层，否则兄弟组件的 v-for 无法渲染 动态数据-->
    <div>
      <Modal
        v-model="visible"
        :footer-hide="true"
        :mask="false"
        :styles="{top: '20px'}"
      >
        <img
          :src="currentImage"
          style="width: 100%"
        >
      </Modal>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ImageList',
  props: {
    images: {
      type: Array,
      default: () => []
    },
    // 是否支持预览
    canPreview: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '80px'
    },
    // 图片填充模式，等同于原生的 object-fit 属性
    fit: {
      type: String,
      default: 'fill'
    }
  },
  data() {
    return {
      visible: false,
      currentImage: ''
    }
  },
  methods: {
    handleView(img) {
      this.currentImage = img
      this.visible = true
    }
  }
}
</script>
<style lang="less" scoped>
.image-list {
  display: flex;
  .image-box {
    position: relative;
    margin-right: 8px;
    background: #fff;
    img {
      width: 100%;
      height: 100%;
    }

    &:hover .image-cover {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .image-cover {
      display: none;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background: rgba(0, 0, 0, 0.6);
      i {
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
      }
    }
  }
}
</style>
